import {DASHBOARD_COLLECTIONS_DSO} from '../../Api/resources/endPoint';
import { serviceName } from '../../Api/resources/serviceConstants';

export const fetchCollectionDSO = (userInfo) => {
  return {
    url: DASHBOARD_COLLECTIONS_DSO,
    method: 'post',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    payload: userInfo,
    service: serviceName.PROJECT_MS,
  };
};
